import Vue from 'vue'
import Router from 'vue-router'
import Wap from '@/components/wap'
import Home from '@/components/Home'
import Download from '@/components/Download'
import Custommade from '@/components/Custommade'
import Authentication from '@/components/Authentication'
import UserAgreement from '@/components/UserAgreement'
import Authstatus from '@/components/Authstatus'

Vue.use(Router)
let routes;
if((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad|hpwOS|SysbianOS|Windows Phone|UCWEB|BlackBerry|Nokia|RIM|IEMobile|Mobile)/i))){
    routes=[
        {
            path: '/',
            redirect: '/wap'
        },
        {
            path:'/wap',
            name: 'wap',
            component: Wap,
            meta: {
                title: 'wap'
            }
        },
    ]
}else{

    routes=[
        {
            path: '/',
            redirect: '/home'
        },
        {
            path:'/home',
            name: 'Home',
            component: Home,
            meta: {
                title: '首页'
            }
        },
        {
            path:'/download',
            name: 'Download',
            component: Download,
            meta: {
                title: '下载app'
            }
        },
        {
            path:'/custommade',
            name: 'Custommade',
            component: Custommade,
            meta: {
                title: '企业定制'
            }
        },
        {
            path:'/authentication',
            name: 'Authentication',
            component: Authentication,
            meta: {
                title: '企业认证'
            }
        },
        {
            path:'/userAgreement',
            name: 'UserAgreement',
            component: UserAgreement,
            meta: {
                title: '微解药用户注册协议'
            }
        },
        {
            path:'/Authstatus',
            name: 'Authstatus',
            component: Authstatus,
            meta: {
                title: '审核状态'
            }
        },
    ]
}
export default new Router({
    routes: routes


})



// WEBPACK FOOTER //
// ./src/router/index.js